module.exports = __webpack_public_path__ + "img/home.81b59a72.svg";